import { Api, ApiResponse } from "common";
import { ActiveBranchResponse } from "./types";

const getActiveBranches = (): ApiResponse<ActiveBranchResponse> => {
  return Api.get("api/ecomm/branch/active/get");
};

export const BranchApi = {
  getActiveBranches,
};
